import React from "react";
import { Col } from "reactstrap";

export default function PricingWidgetList(props) {
  return (
    <React.Fragment>
     <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={12}>
        <div className="p-2 border border-dashed rounded">
          <div
            className="d-flex align-items-center"
            style={{ height: "80px", width: "210px" }}
          >
            <div className="avatar-sm me-2">
              <div className="avatar-title rounded bg-transparent text-success fs-24">
                <i className={props.pricingDetails.icon}></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <p className="text-muted mb-1">
                {props.pricingDetails.label}{" "}
                {props.pricingDetails.labelDetail ? ":" : ""}
              </p>
              <h5 className="mb-0">{props.pricingDetails.labelDetail}</h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
}
